import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/styles/layout.scss'
import './assets/styles/content-blocks.scss'
import './assets/styles/partner-grid.scss'
import './assets/styles/fonts.scss'
import './assets/styles/mobile.scss'
import './style.css'
import { pinia } from '@/pinia/index'
import { setupDirectives } from './common/directives'
import { setupScrollHelper } from './common/utils/scrollHelper'

const app = createApp(App)

app.use(router)
app.use(pinia)
app.use(i18n)
app.use(ElementPlus)

// 注册全局指令
setupDirectives(app)

// 启用滚动辅助工具
setupScrollHelper()

app.mount('#app')
